import { useNavigate } from "react-router-dom";

export const useNavigation = () => {
  const navigate = useNavigate();

  const navigateToAuth = () => {
    navigate("/auth/identity-verification");
  };

  const navigateToTerms = () => {
    navigate("/auth/terms");
  };

  const navigateToIdentityVerification = () => {
    navigate("/auth/identity-verification");
  };

  /**
   * @deprecated 다날 본인인증으로 대체됨. navigateToIdentityVerification 사용
   */
  const navigateToPhoneAuth = () => {
    navigate("/auth/identity-verification");
  };

  const navigateToHome = () => {
    navigate("/");
  };

  const navigateToChat = (chatId: string) => {
    navigate(`/chat/${chatId}`);
  };

  const navigateToSettings = () => {
    navigate("/settings");
  };

  const navigateToServiceTerms = () => {
    navigate("/settings/service-terms");
  };

  const navigateToDataTransfer = () => {
    navigate("/settings/data-transfer");
  };

  const navigateToAccountDeletion = () => {
    navigate("/settings/account-deletion");
  };

  const navigateToMyDataRequest = () => {
    navigate("/settings/mydata-request");
  };

  const navigateToMyDataManagement = () => {
    navigate("/settings/mydata-management");
  };

  const navigateToInstitutionConnection = () => {
    navigate("/settings/institution-connection");
  };

  const navigateToTransmissionDemandDetail = (transmissionDemandId: string) => {
    navigate(`/settings/transmission-demand/${transmissionDemandId}`);
  };

  const navigateToMyDataTermsList = () => {
    navigate("/settings/mydata-terms-list");
  };

  const navigateToConsentHistory = () => {
    navigate("/settings/consent-history");
  };

  const navigateToUsageHistory = () => {
    navigate("/settings/usage-history");
  };

  const navigateToMarketingConsent = () => {
    navigate("/settings/marketing-consent");
  };

  const goBack = () => {
    navigate(-1);
  };

  return {
    navigateToAuth,
    navigateToTerms,
    navigateToIdentityVerification,
    navigateToPhoneAuth,
    navigateToHome,
    navigateToChat,
    navigateToSettings,
    navigateToServiceTerms,
    navigateToDataTransfer,
    navigateToAccountDeletion,
    navigateToMyDataRequest,
    navigateToMyDataManagement,
    navigateToInstitutionConnection,
    navigateToTransmissionDemandDetail,
    navigateToMyDataTermsList,
    navigateToConsentHistory,
    navigateToUsageHistory,
    navigateToMarketingConsent,
    goBack,
  };
};
